import { ref } from "vue";

interface ZoomLevelParams {
  maxZoom?: number;
  minZoom?: number;
  initialZoomLevel?: number;
}

export const useZoomLevel = ({
  maxZoom = 8,
  minZoom = 16,
  initialZoomLevel = 10,
}: ZoomLevelParams) => {
  const MIN_ZOOM_LEVEL = minZoom;
  const MAX_ZOOM_LEVEL = maxZoom;

  let zoomChangedListener: typeof window.naver.maps.MapEventListener | null =
    null;

  const zoomLevel = ref(initialZoomLevel);
  const increaseZoomLevel = (naverMapObj: any) => {
    const currentZoomLevel = naverMapObj.getZoom();
    if (currentZoomLevel >= MAX_ZOOM_LEVEL) return;

    zoomLevel.value = currentZoomLevel + 1;
    naverMapObj.setZoom(zoomLevel.value, true);
  };

  const decreaseZoomLevel = (naverMapObj: any) => {
    const currentZoomLevel = naverMapObj.getZoom();
    if (currentZoomLevel <= MIN_ZOOM_LEVEL) return;

    zoomLevel.value = currentZoomLevel - 1;
    naverMapObj.setZoom(zoomLevel.value, true);
  };

  const addZoomChangedNaverEventListener = (naverMapObj: any) => {
    zoomChangedListener = window.naver.maps.Event.addListener(
      naverMapObj,
      "zoom_changed",
      () => {
        const currentZoom = Math.round(naverMapObj.getZoom());
        zoomLevel.value = currentZoom;
      }
    );
  };

  const removeZoomChangedNaverEventListener = () => {
    if (zoomChangedListener) {
      window.naver.maps.Event.removeListener(zoomChangedListener);
      zoomChangedListener = null;
    }
  };

  return {
    zoomLevel,
    increaseZoomLevel,
    decreaseZoomLevel,
    addZoomChangedNaverEventListener,
    removeZoomChangedNaverEventListener,
  };
};
